/*
 * @overview: 事件注册
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-29 16:39:32
 */

import { options } from "./options";
import {
  injectFetch,
  injectJsError,
  injectXHR,
  injectPerformance,
  injectPV,
  injectUV,
  injectProjectAccess,
} from "../lib";
import { initHttp } from "../api/http";

/**
 * 初始化监听事件
 * @param Vue Vue实例，用于监听Vue项目错误
 * @returns
 */
export const setUp = (Vue) => {
  if (!use()) return;
  // 初始化http配置
  initHttp(options);
  // 性能指标
  // injectPerformance();
  // js错误 资源错误等
  injectJsError(Vue);
  // 请求错误
  injectXHR();
  injectFetch();
  // 用户行为
  // injectPV();
  // injectUV();
  // 项目访问统计
  injectProjectAccess();
};

/**
 * 是否开启监听
 * @returns
 */
const use = () => {
  if (!options.use) {
    console.log("webcrawling 前端监控已关闭");
    return false;
  }
  console.log("webcrawling 前端监控已开启，信息采集中...");
  return true;
};
